/**
 * 銷貨單 detail.lines → 使用庫存扁平列（一筆 allocation 一列）。
 * 僅吃 inline；不另打 candidates／detail。
 */

import {
  formatSalesOrderMaterialLabel,
} from '#/modules/crmMgmt/salesOrder/helper/salesOrderAllocationHelpers';
import {
  getSalesOrderAllocationMtrId,
  getSalesOrderLineInvAllocations,
  getSalesOrderLineMtrs,
} from '#/modules/crmMgmt/salesOrder/helper/salesOrderFieldAccessors';

function formatProductLabel(product) {
  if (!product) {
    return '—';
  }
  const code = String(product.productNo ?? product.code ?? '').trim();
  const name = product.name ? String(product.name).trim() : '';
  if (code && name) {
    return `${code} ${name}`;
  }
  return code || name || '—';
}

function resolveAllocationStockNo(allocation) {
  const stockNo = allocation?.stockNo ?? allocation?.stock_no;
  if (stockNo == null || stockNo === '') {
    return '—';
  }
  return String(stockNo);
}

function resolveAllocationWarehouseLabel(allocation) {
  const warehouse = allocation?.warehouse;
  const label = warehouse?.name
    ?? allocation?.warehouseName
    ?? warehouse?.code
    ?? warehouse?.warehouseName
    ?? '';
  if (label == null || label === '') {
    return '—';
  }
  return String(label);
}

function findLineMtr(line, allocation) {
  const mtrRowId = getSalesOrderAllocationMtrId(allocation);
  if (!mtrRowId) {
    return null;
  }
  return getSalesOrderLineMtrs(line).find(
    (mtr) => String(mtr?.id) === String(mtrRowId),
  ) ?? null;
}

/**
 * @param {object[]|null|undefined} lines
 * @returns {{
 *   id: string,
 *   productLabel: string,
 *   materialLabel: string,
 *   stockNo: string,
 *   warehouseLabel: string,
 *   qty: number|string|null|undefined,
 * }[]}
 */
export function mapSalesOrderAllocationBrowseRows(lines) {
  if (!Array.isArray(lines) || lines.length === 0) {
    return [];
  }

  const rows = [];
  lines.forEach((line, lineIndex) => {
    const productLabel = formatProductLabel(line?.product);
    const allocations = getSalesOrderLineInvAllocations(line);

    allocations.forEach((allocation, allocIndex) => {
      const mtr = findLineMtr(line, allocation);
      const stockId = allocation?.invStockId
        ?? allocation?.inventoryStockId
        ?? allocIndex;
      rows.push({
        id: `${line?.id ?? lineIndex}-${stockId}-${allocIndex}`,
        productLabel,
        materialLabel: formatSalesOrderMaterialLabel(mtr),
        stockNo: resolveAllocationStockNo(allocation),
        warehouseLabel: resolveAllocationWarehouseLabel(allocation),
        qty: allocation?.qty,
      });
    });
  });

  return rows;
}
